import request from '@/request/request'

// 查询智慧灯设置列表
export function listSmartLightSetting(query) {
    return request({
        url: '/api/equipment-server/smartLightSetting/list',
        method: 'get',
        params: query
    })
}

// 查询智慧灯设置详细
export function getSmartLightSettingById(id) {
    return request({
        url: '/api/equipment-server/smartLightSetting/' + id,
        method: 'get'
    })
}

// 新增智慧灯设置
export function addSmartLightSetting(data) {
    return request({
        url: '/api/equipment-server/smartLightSetting',
        method: 'post',
        data: data
    })
}

// 修改智慧灯设置
export function updateSmartLightSetting(data) {
    return request({
        url: '/api/equipment-server/smartLightSetting/edit',
        method: 'post',
        data: data
    })
}

// 删除智慧灯设置
export function delSmartLightSetting(id) {
    return request({
        url: '/api/equipment-server/smartLightSetting/delete/' + id,
        method: 'post'
    })
}


